const reviews = [
  {
    quote: '샌드아트 공연을 처음 봤는데 정말 감동적이었어요. 모래로 이렇게 아름다운 그림을 그릴 수 있다니 놀라웠습니다. 아이들도 눈을 떼지 못했어요.',
    author: '도서관 크리스마스 공연 관람객',
    type: '도서관 샌드아트',
    link: 'https://m.blog.naver.com/kildelee',
    rating: 5,
  },
  {
    quote: '탄소중립 환경보호를 주제로 한 샌드아트 공연이 너무 인상적이었습니다. 아이들이 환경의 소중함을 자연스럽게 느낄 수 있었어요.',
    author: '부산 사상구청 행사 참가 학부모',
    type: '학교 샌드아트',
    link: 'https://m.blog.naver.com/kildelee',
    rating: 5,
  },
  {
    quote: '샌드아트 체험 수업이 정말 특별했어요. 선생님이 친절하게 알려주셔서 아이가 직접 모래로 그림을 완성했을 때 너무 뿌듯해했습니다.',
    author: '체험 프로그램 참가 학부모',
    type: '키즈 체험',
    link: 'https://m.blog.naver.com/kildelee',
    rating: 5,
  },
  {
    quote: '기업 행사에 샌드아트 공연을 섭외했는데 참석자 모두가 극찬했습니다. 회사 비전을 모래로 표현해주신 장면은 정말 감동 그 자체였어요.',
    author: '기업 행사 담당자',
    type: '기업 행사',
    link: 'https://m.blog.naver.com/kildelee',
    rating: 5,
  },
  {
    quote: '크리스마스 분위기를 샌드아트로 표현해주셔서 도서관이 완전히 다른 공간이 된 것 같았어요. 매년 꼭 다시 초청하고 싶습니다.',
    author: '도서관 행사 담당 사서',
    type: '도서관 샌드아트',
    link: 'https://m.blog.naver.com/kildelee',
    rating: 4,
  },
  {
    quote: '아이들이 샌드아트 공연을 보고 나서 집에서도 모래놀이를 하고 싶다고 했어요. 창의력과 예술적 감수성을 키워주는 정말 좋은 프로그램이에요.',
    author: '학교 공연 참가 학부모',
    type: '학교 샌드아트',
    link: 'https://m.blog.naver.com/kildelee',
    rating: 5,
  },
];

export default function Reviews() {
  return (
    <section id="reviews" className="py-32 lg:py-40 bg-warmWhite">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Section Title */}
        <div className="mb-20 lg:mb-28">
          <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">Reviews</p>
          <h2 className="text-3xl lg:text-5xl font-light text-black leading-tight tracking-tight">
            고객의 목소리
          </h2>
          <p className="mt-4 text-sm text-textGray font-light">
            모래요정 k스타샌드아트 네이버 블로그에서 발췌한 실제 후기입니다.
          </p>

          {/* Overall Rating Summary */}
          <div className="mt-10 flex items-center gap-6">
            <div className="flex flex-col items-center justify-center w-20 h-20 border border-lineGray rounded-lg">
              <span className="text-2xl font-semibold text-black leading-none">4.8</span>
              <span className="text-xs text-textGray mt-1 font-light">/ 5.0</span>
            </div>
            <div>
              <div className="flex items-center gap-1 mb-2">
                {[1, 2, 3, 4].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-amber-400"></i>
                ))}
                <i className="ri-star-half-fill text-xl text-amber-400"></i>
              </div>
              <p className="text-xs text-textGray font-light mt-0.5">네이버 블로그 실제 방문 후기 기준</p>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-lineGray mb-14">
          {reviews.map((review, index) => (
            <a
              key={index}
              href={review.link}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-warmWhite px-8 py-10 hover:bg-white transition-colors duration-300 flex flex-col group cursor-pointer"
            >
              <p className="text-xs font-medium tracking-widest uppercase text-primary mb-3">
                {review.type}
              </p>
              {/* Star Rating */}
              <div className="flex items-center gap-0.5 mb-5">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-amber-400"></i>
                ))}
              </div>
              <p className="text-sm lg:text-base text-black font-light leading-relaxed mb-6 flex-1">
                "{review.quote}"
              </p>
              <div className="flex items-center justify-between">
                <p className="text-xs text-textGray font-light tracking-wide">
                  — {review.author}
                </p>
                <i className="ri-arrow-right-line text-xs text-textGray group-hover:text-primary transition-colors"></i>
              </div>
            </a>
          ))}
        </div>

        {/* More Reviews */}
        <div className="text-center">
          <a
            href="https://m.blog.naver.com/PostList.naver?blogId=kildelee&tab=1"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-sm font-light tracking-wide text-black hover:text-primary transition-colors cursor-pointer"
          >
            <span>블로그에서 더 많은 후기 보기</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

      </div>
    </section>
  );
}
